export const POPUP_ANCHOR_VERTICAL = 'bottom';
export const POPUP_ANCHOR_HORIZONTAL = 'left';

export const SMALL_CARD_ELLIPSIS_CHARS_LIMIT = 20;

export const VARIANT_KEYS = {
    danger: 'danger',
    default: 'default',
};

export const STEPS_STATUS = {
    completed: 'completed',
    inProgress: 'inProgress',
    pending: 'pending',
    error: 'error',
};

export const ALERT_TYPE = {
    success: 'success',
    warning: 'warning',
    info: 'info',
    error: 'error',
};

export const pageKeys = {
    ADD_USER: 'ADD_USER',
    EDIT_USER: 'EDIT_USER',
};

export const NEW_FEATURES_DIRECTORY = 'NewFeaturesDirectory';

export const TOGGLE_UNCHECKED = 'toggleUnchecked';
export const TOGGLE_CHECKED = 'toggleChecked';
